export const setPREVIOUSHOME = "setPREVIOUSHOME";
export const setPREVIOUSADMIN = "setPREVIOUSADMIN";
export const setPREVIOUSCURRENT = "setPREVIOUSCURRENT";
